// Generated by CoffeeScript 1.12.6
var sites;

require('angular-resource');

sites = require('goodeggs-sites');

module.exports = __filename;

angular.module(__filename, ['ngResource']).factory('OrderSummaryEmail', [
  '$resource', '$window', function($resource, $window) {
    var baseUrl;
    baseUrl = (sites.getUrl('ops-purchase-orders-api', $window.settings)) + "/v1/order_summary_emails";
    return $resource(baseUrl + "/confirm/:hash", {
      hash: '@hash'
    }, {
      confirm: {
        method: 'POST'
      }
    });
  }
]);
